import {
  FETCH_DATA_REQUEST,
  FETCH_DATA_SUCCESS,
  FETCH_DATA_FAILURE,
  FETCH_DATA_PROGRESS,
  FILE_DOWNLOAD_SUCCESS
} from "./constants";

import { IHomeScreen, IAction } from "./../../../models";

const initialState: IHomeScreen = {
  data: [],
  total: 0,
  anonymousToken: "",
  expireDateTime: "",
  uuid: "",
  error: "",
  status: true,
  file: ''
};

export function reducer(
  state: IHomeScreen = initialState,
  { type, payload }: IAction
): IHomeScreen {
  switch (type) {
    case FETCH_DATA_REQUEST:
      return {
        ...state
      };
    case FETCH_DATA_SUCCESS:
      return {
        ...state,
        anonymousToken: payload.anonymousToken,
        expireDateTime: payload.expireDateTime,
        uuid: payload.uuid,
        data: payload.data,
        total: payload.total,
        status: false
      };
    case FETCH_DATA_FAILURE:
      return {
        ...state,
        error: payload.error,
        status: false
      };
    case FETCH_DATA_PROGRESS:
      return {
        ...state,
        status: payload.status
      };
    case FILE_DOWNLOAD_SUCCESS:
      return {
        ...state,
        file: payload
      };
    default:
      return state;
  }
}
